import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'
import { UserService } from '../../services'
import UserRoutes from './route-types'
import SuperadminUsersRoutes from '../../views/superadmin/user/route-types.js'

const tag = 'user'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  returnRoute: (state) => state.returnRoute,
  currentSnapshot: (state) => state.snapshots[state.currentIndex],
  snapshotDiff: (state) => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  async getStoreItem({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const data = await UserService.getUser(id)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.userId, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  async addStoreItem({ commit, rootState }) {
    const entity = await UserService.getNewEntity()
    StoreUtil.setStorage(entity.userId, tag, entity)
    commit('saveInitialSnapshots', entity)
    const userInfo = rootState.userInfo.data
    if (userInfo.isSystemAdministrator && !userInfo.isSupportUser) {
      return StoreUtil.routeToDetail(SuperadminUsersRoutes.UserView.path, entity.userId, entity.isNew)
    } else StoreUtil.routeToDetail(UserRoutes.UserView.path, entity.userId, entity.isNew)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
